import { render, staticRenderFns } from "./StallionDashboard.vue?vue&type=template&id=326a5540&"
import script from "./StallionDashboard.vue?vue&type=script&lang=js&"
export * from "./StallionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports